const HTML_TAG_REGEX = /<\/?[a-z][\s\S]*?>/i;

export function formatChatbotAnswer(text: string): string {
  if (!text?.trim()) {
    return '';
  }

  if (HTML_TAG_REGEX.test(text)) {
    return text;
  }

  return text
    .split(/\n\n+/)
    .map(formatBlock)
    .filter(Boolean)
    .join('');
}

function formatBlock(block: string): string {
  const lines = block.split('\n').map((line) => line.trim()).filter(Boolean);
  if (!lines.length) {
    return '';
  }

  if (lines.every(isBulletLine)) {
    return formatBulletList(lines);
  }

  const sectionMatch = lines[0].match(/^(\d+\))\s*(.+)$/);
  if (sectionMatch) {
    const header = `<p class="chatbot-answer__section"><strong>${formatInline(`${sectionMatch[1]} ${sectionMatch[2]}`)}</strong></p>`;
    const rest = lines.slice(1);
    if (!rest.length) {
      return header;
    }
    return header + formatLines(rest);
  }

  return `<p class="chatbot-answer__paragraph">${lines.map((line) => formatInline(line)).join('<br>')}</p>`;
}

function formatLines(lines: string[]): string {
  if (lines.every(isBulletLine)) {
    return formatBulletList(lines);
  }

  return `<p class="chatbot-answer__paragraph">${lines.map((line) => formatInline(line)).join('<br>')}</p>`;
}

function formatBulletList(lines: string[]): string {
  const items = lines.map((line) => `<li>${formatInline(stripBullet(line))}</li>`).join('');
  return `<ul class="chatbot-answer__list">${items}</ul>`;
}

function isBulletLine(line: string): boolean {
  return /^[-•]\s+/.test(line.trim());
}

function stripBullet(line: string): string {
  return line.trim().replace(/^[-•]\s+/, '');
}

function formatInline(text: string): string {
  return escapeHtml(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
